import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetOrderListEffect } from './get-order-list.effect';
import { getOrderListReducer } from './get-order-list.reducer';
import { GET_ORDER_LIST_STORE_NAME, GetOrderListState } from './get-order-list.state';

/** Token of the GetOrderList reducer */
export const GET_ORDER_LIST_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetOrderListState, Action>>(
  'Feature GetOrderList Reducer'
);

/** Provide default reducer for GetOrderList store */
export function getDefaultGetOrderListReducer() {
  return getOrderListReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_ORDER_LIST_STORE_NAME, GET_ORDER_LIST_REDUCER_TOKEN),
    EffectsModule.forFeature([GetOrderListEffect]),
  ],
  providers: [{ provide: GET_ORDER_LIST_REDUCER_TOKEN, useFactory: getDefaultGetOrderListReducer }],
})
export class GetOrderListStoreModule {
  public static forRoot<T extends GetOrderListState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetOrderListStoreModule> {
    return {
      ngModule: GetOrderListStoreModule,
      providers: [{ provide: GET_ORDER_LIST_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
